/**
 * Shared validation utilities for DFP plugins
 * Provides consistent validation patterns across all components
 */

/**
 * Validation regex patterns for form inputs
 */
export const VALIDATION_PATTERNS = {
  PROJECT_KEY: /^[a-z0-9_-]*$/,
  DEBT_ITEM_ID: /^[a-z0-9_-]*$/,
  PROJECT_NAME: /^[a-zA-Z0-9_-]*$/,
  INTEGER: /^\d+$/,
  DECIMAL: /^\d*\.?\d*$/,
} as const;

/**
 * Validate project key format
 * @param value - Value to validate
 * @returns True if valid
 */
export const validateProjectKey = (value: string): boolean => {
  return VALIDATION_PATTERNS.PROJECT_KEY.test(value);
};

/**
 * Validate debt item ID format
 * @param value - Value to validate
 * @returns True if valid
 */
export const validateDebtItemId = (value: string): boolean => {
  return VALIDATION_PATTERNS.DEBT_ITEM_ID.test(value);
};

/**
 * Validate project name format
 * @param value - Value to validate
 * @returns True if valid
 */
export const validateProjectName = (value: string): boolean => {
  return VALIDATION_PATTERNS.PROJECT_NAME.test(value);
};

/**
 * Validate integer format
 * @param value - Value to validate
 * @returns True if valid integer
 */
export const validateInteger = (value: string): boolean => {
  return VALIDATION_PATTERNS.INTEGER.test(value);
};

/**
 * Validate decimal format
 * @param value - Value to validate
 * @returns True if valid decimal
 */
export const validateDecimal = (value: string): boolean => {
  return VALIDATION_PATTERNS.DECIMAL.test(value);
};
